import { CellValue, ColumnType, ITypeOptions } from '../../types';

export const transformCellValueToSubtableArray = <
  OT extends ColumnType = ColumnType
>({
  originCellValue,
  originTypeOptions,
  targetTypeOptions,
}: {
  originCellValue: CellValue<OT>;
  originTypeOptions: ITypeOptions<OT>;
  targetTypeOptions: Pick<
    ITypeOptions<ColumnType.SUBTABLE>,
    'foreignTableId'
  >;
}) => {
  if (
    originTypeOptions.type === ColumnType.SUBTABLE && 
    targetTypeOptions.foreignTableId ===
      (originTypeOptions as ITypeOptions<ColumnType.SUBTABLE>)
        .foreignTableId
  ) {
    return originCellValue as CellValue<ColumnType.SUBTABLE>;
  }

  return null;
};
